import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminLeads = lazy(() => import("@/pages/admin/AdminLeads"));

export const Route = createFileRoute("/admin/leads")({
  component: () => <AdminLeads />,
});
